import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Dropdown, Menu, Space, Typography } from "antd";
import {
  AppleOutlined,
  AndroidOutlined,
  DownOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import {
  LanguageProvider,
  useLanguage,
} from "../Home/LanguageContext";
import { TopMenu } from "../Home/TopMenu";
import "./UserPreviewPage.css";

const { Title, Paragraph } = Typography;

const UserPreviewContent: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const { t, language } = useLanguage();
  const [showBazaarLink, setShowBazaarLink] = useState(false);

  useEffect(() => {
    fetch("/api/settings")
      .then((res) => res.json())
      .then((data) => {
        if (data?.data) {
          const bazaarSetting = data.data.find(
            (s: { key: string }) => s.key === "show-bazaar-download-link"
          );
          setShowBazaarLink(
            bazaarSetting?.value === "true" || bazaarSetting?.value === true
          );
        }
      })
      .catch(() => {});
  }, []);

  const isRtl = language === "fa" || language === "ar";
  const androidMenu = (
    <Menu className={isRtl ? "rtl" : ""}>
      <Menu.Item key="playstore" icon={<AndroidOutlined />}>
        <a
          href="https://play.google.com/store/apps/details?id=com.parsa.lingua_talk"
          className="download-menu-item"
        >
          Google Play Store
        </a>
      </Menu.Item>
      {showBazaarLink && (
        <Menu.Item key="bazaar" icon={<AndroidOutlined />}>
          <a
            href="https://cafebazaar.ir/app/com.parsa.lingua_talk"
            className="download-menu-item"
          >
            کافه بازار
          </a>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div
      className={`home-container user-preview-container ${isRtl ? "rtl" : ""}`}
    >
      <TopMenu />
      <div className="user-preview-center">
        <div className="user-preview-card">
          <div className="user-preview-brand">
            <TeamOutlined className="user-preview-brand-icon" />
            <span className="user-preview-brand-name">Lingua Talk</span>
          </div>
          <p className="user-preview-tagline">{t("userPreviewTagline")}</p>
          <Title level={2} className="user-preview-title">
            {t("userPreviewTitle")}
          </Title>
          <Paragraph className="user-preview-message">
            {t("userPreviewMessage")}
          </Paragraph>
          <div className="user-preview-actions">
            <div className="user-preview-buttons">
              <Button
                type="primary"
                size="large"
                icon={<AppleOutlined />}
                className="user-preview-btn user-preview-btn-ios"
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/us/app/lingua-talk/id6746571204"
                  )
                }
              >
                {t("downloadIOS")}
              </Button>
              {showBazaarLink ? (
                <Dropdown
                  overlay={androidMenu}
                  trigger={["click"]}
                  placement="bottomCenter"
                  overlayClassName={isRtl ? "rtl-dropdown" : ""}
                >
                  <Button
                    type="primary"
                    size="large"
                    className="user-preview-btn user-preview-btn-android"
                  >
                    <Space>
                      <AndroidOutlined />
                      {t("downloadAndroid")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              ) : (
                <Button
                  type="primary"
                  size="large"
                  icon={<AndroidOutlined />}
                  className="user-preview-btn user-preview-btn-android"
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.parsa.lingua_talk"
                    )
                  }
                >
                  {t("downloadAndroid")}
                </Button>
              )}
            </div>
            {userId && (
              <a
                href={`lintalk://u/${userId}`}
                className="user-preview-open-app"
              >
                {t("userPreviewOpenInApp")}
              </a>
            )}
            <p className="user-preview-hint">{t("userPreviewHint")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserPreviewPage: React.FC = () => (
  <LanguageProvider>
    <UserPreviewContent />
  </LanguageProvider>
);

export default UserPreviewPage;
